module.exports = __webpack_public_path__ + "static/img/4.6a80487c.jpg";